import { UserSelect } from "./User";
export var SharePageInclude = {
    certifications: { where: { deleted: false } },
    sustainabilityReports: { where: { deleted: false } },
    stories: { where: { deleted: false } },
    organization: true,
    user: {
        select: UserSelect
    },
};
//# sourceMappingURL=SharePage.js.map